import { render, staticRenderFns } from "./table-columns-menu.vue?vue&type=template&id=7840a64a&scoped=true&"
import script from "./table-columns-menu.vue?vue&type=script&lang=js&"
export * from "./table-columns-menu.vue?vue&type=script&lang=js&"
import style0 from "./table-columns-menu.vue?vue&type=style&index=0&id=7840a64a&prod&lang=scss&scoped=true&"
import style1 from "./table-columns-menu.vue?vue&type=style&index=1&id=7840a64a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840a64a",
  null
  
)

export default component.exports